import { styled } from '@mui/material/styles';
import { Box, IconButton } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { createColorFilteredComponent, createPrefixedPropsFilteredComponent } from 'helpers/styledHelpers';

export const StyledTableContainer = styled(Box)({
  width: '100%',
});

export const StyledLoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50vh',
});

export const StyledRewardContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledStarIcon = createColorFilteredComponent<{ $color: string }>(StarIcon)(({ $color }) => ({
  color: $color
})); 

export const StyledTableHeader = createPrefixedPropsFilteredComponent<{ $textAlign: string }>('th')(({ $textAlign }) => ({
  textAlign: $textAlign,
}));

export const StyledIconButton = styled(IconButton)({
  marginRight: '2rem',
});